import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { setCookie, getCookie } from '../utils/cookies';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Always begin with Dutch so the first client render matches the pre-rendered HTML.
  const [language, setLanguage] = useState('nl');
  const isInitialLanguageSave = useRef(true);

  useEffect(() => {
    const savedLanguage = getCookie('language');
    if (savedLanguage === 'nl' || savedLanguage === 'en') {
      setLanguage(savedLanguage);
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  useEffect(() => {
    if (isInitialLanguageSave.current) {
      isInitialLanguageSave.current = false;
      return;
    }

    setCookie('language', language, 365);
  }, [language]);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
